import * as React from 'react'
import { usePricingConfigQuery, PricingConfigType } from '@root/queriesAndMutations/pricingConfig'
import { defaultPricingConfig } from '@root/appData'

type PricingConfigContextType = {
	pricingConfig: PricingConfigType
	isLoading: boolean
}

const PricingConfigContext = React.createContext<PricingConfigContextType>({
	pricingConfig: defaultPricingConfig,
	isLoading: true,
})

export const PricingConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { data: pricingConfig, isLoading } = usePricingConfigQuery()

	const value = React.useMemo(
		() => ({
			pricingConfig: pricingConfig || defaultPricingConfig,
			isLoading,
		}),
		[pricingConfig, isLoading]
	)

	return <PricingConfigContext.Provider value={value}>{children}</PricingConfigContext.Provider>
}

export const usePricingConfig = (): PricingConfigContextType => {
	const context = React.useContext(PricingConfigContext)
	if (!context) {
		throw new Error('usePricingConfig must be used within PricingConfigProvider')
	}
	return context
}
